import type { GridColDef, GridValueGetterParams } from '@mui/x-data-grid-pro';
import { formatEightDecimalsNumber, formatNumber } from 'utils/number';

export interface MovimentacaoRelatorioCampos {
  nomeInvestidor?: string;
  quantidadeDisponivel?: number;
  puAtualizado?: number;
}

export const obterNomeInvestidor = (movimentacao: MovimentacaoRelatorioCampos): string =>
  movimentacao?.nomeInvestidor ?? '';

export const obterQuantidadeDisponivelFormatada = (movimentacao: MovimentacaoRelatorioCampos): string =>
  movimentacao?.quantidadeDisponivel != null
    ? formatNumber(movimentacao.quantidadeDisponivel, { minimumFractionDigits: 0, maximumFractionDigits: 8 })
    : '';

export const obterPuAtualizadoFormatado = (movimentacao: MovimentacaoRelatorioCampos): string =>
  movimentacao?.puAtualizado != null ? formatEightDecimalsNumber(movimentacao.puAtualizado) : '';

export const TEXTO_POSSUI_DOCUMENTO = 'Possui documento';
export const TEXTO_SEM_DOCUMENTO = 'Sem documento';

export const TEXTO_EXPORTACAO_POSSUI_DOCUMENTO = 'Sim';
export const TEXTO_EXPORTACAO_SEM_DOCUMENTO = 'Não';

export const VALOR_SELECAO_POSSUI_DOCUMENTO = 'TRUE';
export const VALOR_SELECAO_SEM_DOCUMENTO = 'FALSE';

export const obterTextoDocumento = (possuiDocumento?: boolean): string =>
  possuiDocumento === true ? TEXTO_POSSUI_DOCUMENTO : TEXTO_SEM_DOCUMENTO;

export const obterTextoDocumentoExportado = (possuiDocumento?: boolean): string =>
  possuiDocumento === true ? TEXTO_EXPORTACAO_POSSUI_DOCUMENTO : TEXTO_EXPORTACAO_SEM_DOCUMENTO;

export const obterValorSelecaoDocumento = (possuiDocumento?: boolean): string =>
  possuiDocumento === true ? VALOR_SELECAO_POSSUI_DOCUMENTO : VALOR_SELECAO_SEM_DOCUMENTO;

export const colunasRelatorioMovimentacao: Array<GridColDef> = [
  {
    field: 'NOME_INVESTIDOR',
    headerName: 'Nome Investidor',
    type: 'string',
    filterable: false,
    sortable: false,
    disableExport: false,
    width: 220,
    minWidth: 150,
    maxWidth: 320,
    valueGetter: (params: GridValueGetterParams) =>
      obterNomeInvestidor(params.row as MovimentacaoRelatorioCampos),
  },
  {
    field: 'QUANTIDADE_DISPONIVEL',
    headerName: 'Quantidade disponível',
    type: 'string',
    filterable: false,
    sortable: false,
    disableExport: false,
    width: 170,
    minWidth: 140,
    maxWidth: 220,
    valueGetter: (params: GridValueGetterParams) =>
      obterQuantidadeDisponivelFormatada(params.row as MovimentacaoRelatorioCampos),
  },
  {
    field: 'PU_ATUALIZADO',
    headerName: 'PU atualizado (D0)',
    type: 'string',
    filterable: false,
    sortable: false,
    disableExport: false,
    width: 170,
    minWidth: 140,
    maxWidth: 220,
    valueGetter: (params: GridValueGetterParams) =>
      obterPuAtualizadoFormatado(params.row as MovimentacaoRelatorioCampos),
  },
];
